import { ColumnDef } from "@tanstack/react-table";
import { TableScrollableCell } from "src/components-mui/base/table-scrollable/components/cell/table-scrollable-cell";
import { TableCellSkeleton } from "src/components-mui/base/table-scrollable/components/skeleton/table-cell-skeleton";
import { TableEntitySkeleton } from "src/components-mui/base/table-scrollable/components/skeleton/table-entity-skeleton";
import { TABLE_FIRST_COLUMN_WIDTH } from "src/components-mui/base/table-scrollable/constants";
import { TableFirstColumnWidth } from "src/components-mui/base/table-scrollable/table-scrollable.types";

interface IMakeTableScrollableLoadingColumnsParams<T extends object> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    columns: ColumnDef<T, any>[];
    isFirstCellAvatar?: boolean;
    sorting?: boolean;
    disableAnimation?: boolean;
    skeletonBackgroundColor?: string;
    firstColumnWidth?: TableFirstColumnWidth;
}

export const makeTableScrollableLoadingColumns = <T extends object>({
    columns,
    isFirstCellAvatar = false,
    sorting = false,
    disableAnimation = false,
    skeletonBackgroundColor,
    firstColumnWidth,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
IMakeTableScrollableLoadingColumnsParams<T>): ColumnDef<T, any>[] => {
    return columns.map((column, index) => {
        const isFirstColumn = index === 0 && isFirstCellAvatar;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const cellRenderer: any = isFirstColumn
            ? () => (
                  <TableScrollableCell shrinkable width={firstColumnWidth ?? TABLE_FIRST_COLUMN_WIDTH}>
                      <TableEntitySkeleton animation={disableAnimation ? false : "pulse"} backgroundColor={skeletonBackgroundColor} />
                  </TableScrollableCell>
              )
            : () => (
                  <TableScrollableCell>
                      <TableCellSkeleton animation={disableAnimation ? false : "pulse"} backgroundColor={skeletonBackgroundColor} />
                  </TableScrollableCell>
              );

        return {
            ...column,
            header: column.header,
            cell: cellRenderer,
            enableSorting: sorting,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } as ColumnDef<T, any>;
    });
};
